/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSelector } from "react-redux";
import { getAllPriorityByEntity } from "redux/memoizedSelectors";
import EditModeSwitch from "shared/components/edit-mode-switch";
import { SwitchProvider } from "shared/dynamic-imports";
import PriorityItem from "shared/ui-basics/ui-components/PriorityItem";
import GenericTypeahead from "../GenericTypeahead";

type RecordType = "cem_cxopportunity" | "cem_cxsolution" | "cem_cxactiontask" | "project" | "insight";
type Props = {
	recordType: RecordType;
	attributeName: string;
	entityType: string;
	object: any;
	link: (id: string) => void;
	unlink: (id: string) => void;
	isSwitchDisabled?: boolean;
	menuListHeight?: string;
	isOpen?: boolean;
};

export default function PriorityDropdown(props: Props): JSX.Element {
	const { object, attributeName, recordType, isSwitchDisabled = false, link, unlink, menuListHeight, isOpen = false } = props;
	const currentPriorityId = object?.[attributeName] || "";
	const prioritiesTypes: any = useSelector(getAllPriorityByEntity({ entity: getStatusEntityPath(recordType) }));
	const currentPriority = prioritiesTypes?.find((s: any) => s.id === currentPriorityId);
	const linkedPriorities: any[] = currentPriority ? [currentPriority] : [];
	const renderReadOnlyItems = () => (
		<>
			{linkedPriorities?.map((priority) => (
				<div key={priority?.id}>
					<PriorityItem priority={priority} />
				</div>
			))}
		</>
	);

	const params = {
		selected: linkedPriorities,
		options: prioritiesTypes,
		renderSelectedItem: (item: any) => <PriorityItem key={item?.id} priority={item} isEdit={true} handleRemove={unlink} />,
		renderMenuItem: ({ item }: any) => <PriorityItem priority={item} />,
		linkMenuItem: ({ item, close }: any) => {
			link(item.id);
			close();
		},
		filter: ({ query, option }: any) => {
			const it = prioritiesTypes.find((s: any) => s.id === option?.id);
			if (it && !linkedPriorities.map((li) => li?.id)?.includes(option?.id)) return it?.name?.toLowerCase().includes(query?.toLowerCase());
		},
		menuListHeight,
		isStrictOpen: isOpen ? isOpen : null,
	};

	return (
		<SwitchProvider initialValue={isOpen} isDisabled={isSwitchDisabled}>
			<EditModeSwitch addLabel="ADD_PRIORITY" renderReadOnlyItems={renderReadOnlyItems} isEmpty={linkedPriorities?.length === 0} isDisabled={isSwitchDisabled}>
				<GenericTypeahead {...params} />
			</EditModeSwitch>
		</SwitchProvider>
	);
}

function getStatusEntityPath(recordType: RecordType) {
	// how we receive the data from the server
	switch (recordType) {
		case "cem_cxopportunity":
			return "opportunity";
		case "cem_cxsolution":
			return "solutions";
		case "cem_cxactiontask":
			return "cxActions";
		case "project":
			return "project";
		case "insight":
			return "insight";
		default:
			return null;
	}
}
